import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function startSerpAnalysis(pageId, candidateId, location = null) {
  return axios.post(`/ajax/website_pages/${pageId}/analyze_serp`, { candidate_id: candidateId, location })
}

export function getSerpAnalysis(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/serp_analysis`)
}

export function confirmSerpAnalysis(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/confirm_serp_analysis`)
}
